var React = require('react');

function IconFaq4 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M21.5 8.77778V14.3333M15.9444 21V16.5556C15.9444 15.9662 16.1786 15.401 16.5953 14.9842C17.0121 14.5675 17.5773 14.3333 18.1667 14.3333H24.8333C25.4227 14.3333 25.9879 14.5675 26.4047 14.9842C26.8214 15.401 27.0556 15.9662 27.0556 16.5556V21M10.3889 40.7772V23.2222C10.3889 22.6329 10.623 22.0676 11.0398 21.6509C11.4565 21.2341 12.0217 21 12.6111 21H30.3889C30.9783 21 31.5435 21.2341 31.9602 21.6509C32.377 22.0676 32.6111 22.6329 32.6111 23.2222V40.7772M15.9444 27.6667H27.0556M15.9444 34.3333H27.0556M12.6111 1H30.3889C36.5254 1 41.5 5.97461 41.5 12.1111V29.8889C41.5 36.0254 36.5254 41 30.3889 41H12.6111C6.47461 41 1.5 36.0254 1.5 29.8889V12.1111C1.5 5.97461 6.47461 1 12.6111 1Z","stroke":"#ffffff","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"}));
}

IconFaq4.defaultProps = {"viewBox":"0 0 43 42","fill":"none"};

module.exports = IconFaq4;

IconFaq4.default = IconFaq4;
